/** Pick three distinct pieces once per page/section load; no tracking or timers. */
function randomizeRelated(scope = document) {
  scope.querySelectorAll('.sm-product-related[data-random-related]').forEach((section) => {
    if (section.hasAttribute('data-randomized')) return;
    const grid = section.querySelector('.sm-product-related__grid');
    const pool = section.querySelector('template[data-related-pool]');
    if (!grid || !pool) return;

    const pieces = [...grid.children, ...pool.content.children];
    // Fisher–Yates samples without replacement, including the server fallback.
    for (let index = pieces.length - 1; index > 0; index--) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [pieces[index], pieces[randomIndex]] = [pieces[randomIndex], pieces[index]];
    }
    grid.replaceChildren(...pieces.slice(0, 3));
    pool.remove();
    section.setAttribute('data-randomized', '');
  });
}

randomizeRelated();
document.addEventListener('shopify:section:load', (event) => randomizeRelated(event.target));
